import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";
import { useT } from "@/i18n/I18nContext";
import { Facebook, Instagram, Twitter, ShieldCheck, MessagesSquare, Clock, Mail } from "lucide-react";

const socials = [
  { key: "facebook", Icon: Facebook },
  { key: "instagram", Icon: Instagram },
  { key: "twitter", Icon: Twitter },
];

export const Footer = () => {
  const brand = useBrand();
  const { t } = useT();
  return (
    <footer className="bg-foreground text-background mt-20">
      <div className="container-page py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <div className="flex items-center gap-2.5">
            <span className="h-11 w-11 rounded-full bg-white overflow-hidden flex items-center justify-center">
              <img src={brand.logoUrl} alt={brand.name} className="h-10 w-10 object-contain" />
            </span>
            <span className="font-heading font-extrabold text-xl">{brand.name}</span>
          </div>
          <p className="mt-4 text-sm text-background/70 leading-relaxed">{brand.description}</p>
          {brand.community && (
            <a href={brand.community} target="_blank" rel="noreferrer" data-testid="footer-community"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-success px-5 py-2.5 text-sm font-bold text-white hover:opacity-90 transition-opacity">
              <MessagesSquare className="h-4 w-4" /> {t("common.community")}
            </a>
          )}
          {brand.deliveryHours && (
            <p className="mt-4 text-xs text-background/60 flex items-center gap-1.5" data-testid="footer-hours">
              <Clock className="h-3.5 w-3.5" /> {t("order.deliveryHoursLabel")} : {brand.deliveryHours} · {t("order.ordersAround")}
            </p>
          )}
          <div className="flex gap-3 mt-6">
            {socials.map(({ key, Icon }) =>
              brand.social?.[key] ? (
                <a key={key} href={brand.social[key]} target="_blank" rel="noreferrer" data-testid={`social-${key}`}
                  className="h-10 w-10 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                  <Icon className="h-4 w-4" />
                </a>
              ) : null
            )}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4">{t("nav.catalogue")}</h4>
          <ul className="space-y-2.5 text-sm text-background/70">
            <li><Link to="/" className="hover:text-primary transition-colors" data-testid="footer-home">{t("nav.home")}</Link></li>
            <li><Link to="/catalogue" className="hover:text-primary transition-colors" data-testid="footer-catalogue">{t("nav.catalogue")}</Link></li>
            <li><Link to="/catalogue?category=poulet-local" className="hover:text-primary transition-colors">{t("categories.poulet-local")}</Link></li>
            <li><Link to="/catalogue?category=pintade" className="hover:text-primary transition-colors">{t("categories.pintade")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4">{brand.name}</h4>
          <p className="text-sm text-background/70 leading-relaxed flex items-start gap-2">
            <ShieldCheck className="h-4 w-4 text-primary mt-0.5 shrink-0" />
            {t("listing.exchangeHint")}
          </p>
          <a href="mailto:contact@ovolaay.com" className="mt-4 inline-flex items-center gap-2 text-sm text-background/80 hover:text-primary transition-colors" data-testid="footer-email">
            <Mail className="h-4 w-4" /> contact@ovolaay.com
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-page py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-background/55">
          <span>© {new Date().getFullYear()} {brand.name}. Tous droits réservés.</span>
          <span>{brand.region}</span>
        </div>
      </div>
    </footer>
  );
};
